import MapTilesModal from "./MapTilesModal";

export default function MapViewModal() {
  return (
    <div className="flex flex-col gap-8">
      <MapTilesModal />
    </div>
  );
}
